import React from 'react';
import './styles.css';
export default function AppInfoDisplay(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React.createElement("span", {
    className: "app-info-display"
  }, name);
}